import { render, staticRenderFns } from "./CoffeeOrderDetail.vue?vue&type=template&id=f19cbee4&scoped=true&"
import script from "./CoffeeOrderDetail.vue?vue&type=script&lang=js&"
export * from "./CoffeeOrderDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f19cbee4",
  null
  
)

export default component.exports